// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"270":"9c785250","300":"224db064","463":"7d53c767","505":"e74bcfdd","795":"3dee96e3"}[chunkId] + ".css";
};